import { Label } from '@silverfort/sf-components';
import TextInput from '../../../sf-components/TextInput/TextInput';
import { FC } from 'react';

interface SchedulerFieldProps {
    label: string;
    placeholder: string;
    value: string;
    fieldName: string;
    inputType?: string;
    updateSchedulerField: (fieldName: string, fieldValue: string) => void;
}

const SchedulerField: FC<SchedulerFieldProps> = ({
    label,
    placeholder,
    value,
    fieldName,
    inputType = 'text',
    updateSchedulerField
}) => {
    return (
        <div className="flex items-center">
            <div className="min-w-[128px]">
                <Label text={label} />
            </div>
            <div className="w-full">
                <TextInput
                    onChange={(fieldValue) => updateSchedulerField(fieldName, fieldValue)}
                    value={value}
                    placeholder={placeholder}
                    className="w-[100%]"
                    type={inputType}
                />
            </div>
        </div>
    );
};

export default SchedulerField;
